import { contactData } from '@/mocks/homepage';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-medium mb-4">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-mail-send-line text-sm"></i>
            </div>
            联系我们
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading mb-3">
            {contactData.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            {contactData.intro}
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/60 p-6 md:p-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-accent-600 text-lg"></i>
              </div>
              <div>
                <div className="text-sm font-medium text-foreground-700 mb-1">电子邮箱</div>
                <div className="text-sm text-foreground-900 font-mono">{contactData.email}</div>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-wechat-line text-accent-600 text-lg"></i>
              </div>
              <div>
                <div className="text-sm font-medium text-foreground-700 mb-1">微信</div>
                <div className="text-sm text-foreground-900 font-mono">{contactData.wechat}</div>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-qq-line text-accent-600 text-lg"></i>
              </div>
              <div>
                <div className="text-sm font-medium text-foreground-700 mb-1">QQ客服</div>
                <div className="text-sm text-foreground-900 font-mono">{contactData.qq}</div>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-time-line text-accent-600 text-lg"></i>
              </div>
              <div>
                <div className="text-sm font-medium text-foreground-700 mb-1">工作时间</div>
                <div className="text-sm text-foreground-900">{contactData.hours}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}